/**
 * button theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/button.ts
 */
import { defineRecipe } from '@chakra-ui/react';
export const button = defineRecipe({
    base: {},
    variants: {
        variant: {
            primary: {
                bgColor: 'primary',
                color: 'background.offWhite',
                rounded: '8px',
                borderWidth: '2px',
                borderColor: 'text.default',
                boxShadow: '2px 2px 0px 0px {colors.text.default}',
                _active: {
                    bg: '#c13299',
                    boxShadow: 'unset',
                },
                _disabled: {
                    opacity: 1,
                    borderColor: 'state.disabled',
                    bgColor: 'state.disabledBg',
                    color: 'state.disabled',
                    boxShadow: '2px 2px 0px 0px {colors.state.disabled}',
                },
            },
            secondary: {
                color: 'primary',
                rounded: '8px',
                borderWidth: '2px',
                borderColor: 'primary',
                _active: {
                    opacity: '0.5',
                },
                _disabled: {
                    opacity: 1,
                    borderColor: 'state.disabled',
                    color: 'state.disabled',
                },
            },
            tertiary: {
                h: 'auto',
                color: 'primary',
                px: 0,
                _active: {
                    opacity: '0.5',
                },
                _disabled: {
                    color: 'state.disabled',
                },
            },
            icon: {
                w: '32px',
                h: '32px',
                color: 'text.default',
                rounded: 'full',
                borderWidth: '1px',
                borderColor: 'text.default',
                px: '0px',
                _active: {
                    color: 'background.offWhite',
                    borderWidth: '1px',
                    borderColor: 'primary',
                    bgColor: 'primary',
                },
            },
            chip: {
                borderWidth: '2px',
                borderColor: 'text.default',
                color: 'text.default',
                _hover: {
                    opacity: '0.6',
                },
                _active: {
                    bg: 'secondary.persianBlue',
                    borderColor: 'secondary.persianBlue',
                    color: 'background.skyBlue',
                    _hover: {
                        opacity: 1,
                    },
                },
                _disabled: {
                    bg: 'state.disabledBg',
                    color: 'state.disabled',
                    borderColor: 'state.disabledBg',
                },
            },
            ghost: {
                color: 'text.default',
                _hover: {
                    bg: 'state.disabledBg/40',
                },
            },
        },
        size: {
            sm: {
                h: '36px',
                minW: 'auto',
                textStyle: 'body2Bold',
                px: '12px',
                gap: '4px',
            },
            md: {
                h: '48px',
                minW: 'auto',
                textStyle: 'cta',
                px: '16px',
                gap: '4px',
            },
            xs: {
                h: '24px',
                minW: '24px',
            },
        },
    },
    compoundVariants: [
        {
            size: 'sm',
            variant: 'chip',
            css: {
                h: '24px',
                rounded: '12px',
                textStyle: 'caption',
                px: '12px',
                gap: '4px',
            },
        },
        {
            size: 'md',
            variant: 'chip',
            css: {
                h: '30px',
                rounded: '15px',
                textStyle: 'body3',
                px: '12px',
                gap: '8px',
            },
        },
    ],
    defaultVariants: {
        size: 'md',
        variant: 'primary',
    },
});
